const settingsUrlMappings = {
  EMAIL: {
    from: 'email',
    to: '/settings/**{portalId}**/marketing/email'
  },
  SOCIAL: {
    from: 'social',
    to: '/social/**{portalId}**/settings'
  },
  SOCIAL_REPORTS: {
    from: 'social-reports',
    to: '/social/**{portalId}**/settings'
  },
  SOCIAL_INSIGHTS: {
    from: 'social-insights',
    to: '/social/**{portalId}**/settings'
  },
  ADS: {
    from: 'ads',
    to: '/settings/**{portalId}**/marketing/ads'
  },
  FORMS: {
    from: 'forms',
    to: '/settings/**{portalId}**/marketing/form'
  },
  DEALS: {
    from: /(sales|contacts)\/\d+\/(deals|objects\/0-3)/i,
    to: '/sales-products-settings/**{portalId}**/deals'
  },
  TASKS: {
    from: 'tasks',
    to: '/settings/**{portalId}**/user-preferences/tasks'
  },
  MEETINGS: {
    from: 'meetings',
    to: '/settings/**{portalId}**/user-preferences/calendar'
  },
  KNOWLEDGE_BASE: {
    from: 'knowledge',
    to: '/service-hub-settings/**{portalId}**'
  },
  TICKETS: {
    from: /(sales|contacts)\/\d+\/(tickets|objects\/0-5\/)/i,
    to: '/sales-products-settings/**{portalId}**/tickets'
  },
  CONTACTS: {
    from: /(sales|contacts)\/\d+\/(contacts|objects\/0-1\/)/i,
    to: '/sales-products-settings/**{portalId}**/contacts'
  },
  COMPANIES: {
    from: /(sales|contacts)\/\d+\/(companies|objects\/0-2)/i,
    to: '/sales-products-settings/**{portalId}**/companies'
  },
  ANALYTICS_TOOLS: {
    from: 'analytics',
    to: '/settings/**{portalId}**/analytics-and-tracking'
  },
  CUSTOM_REPORTS: {
    from: 'reports',
    to: '/settings/**{portalId}**/analytics-and-tracking'
  },
  CONTACT: {
    from: /(sales|contacts)\/\d+\/(record\/0-1|contact)/i,
    to: '/sales-products-settings/**{portalId}**/contacts'
  },
  COMPANY: {
    from: /(sales|contacts)\/\d+\/(record\/0-2|company)/i,
    to: '/sales-products-settings/**{portalId}**/companies'
  },
  DEAL: {
    from: /(sales|contacts)\/\d+\/(record\/0-3|deal)/i,
    to: '/sales-products-settings/**{portalId}**/deals'
  },
  TICKET: {
    from: /(sales|contacts)\/\d+\/(record\/0-5|ticket)/i,
    to: '/sales-products-settings/**{portalId}**/tickets'
  },
  INBOX: {
    from: 'live-messages',
    to: '/live-messages-settings/**{portalId}**/inboxes'
  },
  BLOGS: {
    from: /(website|blog)\/\d+\/(blog)/i,
    to: '/settings/**{portalId}**/website/blogs'
  },
  SITE_PAGES: {
    from: /(website|pages)\/\d+\/(pages\/site|manage\/site)/i,
    to: '/settings/**{portalId}**/website/pages/'
  },
  LANDING_PAGES: {
    from: /(website|pages)\/\d+\/(pages\/landing|manage\/landing)/i,
    to: '/settings/**{portalId}**/website/pages/'
  },
  PAGE_EDITOR: {
    from: /content\/\d+\/edit/i,
    to: '/settings/**{portalId}**/website/pages/'
  },
  BLOG_EDITOR: {
    from: /blog\/\d+\/edit/i,
    to: '/settings/**{portalId}**/website/blogs'
  },
  BLOG_DETAIL_PAGE: {
    from: /content-detail\/\d+\/blog-post/i,
    to: '/settings/**{portalId}**/website/blogs'
  },
  SITE_DETAIL_PAGE: {
    from: /content-detail\/\d+\/(site-page|landing-page)/i,
    to: '/settings/**{portalId}**/website/pages/'
  },
  FORECASTING: {
    from: 'forecasting',
    to: '/settings/**{portalId}**/sales/forecasting'
  },
  QUOTES: {
    from: 'quotes',
    to: '/settings/**{portalId}**/sales/quotes'
  },
  LINE_ITEMS: {
    from: 'line-items',
    to: '/sales-products-settings/**{portalId}**/deals'
  },
  CALL: {
    from: /calls\/\d+\/review/i,
    to: '/settings/**{portalId}**/calling/callconfigurations'
  },
  CALLS: {
    from: /contacts\/\d+\/objects\/0-48/i,
    to: '/settings/**{portalId}**/calling/callconfigurations'
  },
  PAYMENTS: {
    from: /contacts\/\d+\/objects\/0-101/i,
    to: '/settings/**{portalId}**/sales/payments'
  },
  PAYMENT_LINKS: {
    from: 'payment-links',
    to: '/settings/**{portalId}**/sales/payment-links'
  },
  INVOICES: {
    from: /contacts\/\d+\/objects\/0-53/i,
    to: '/settings/**{portalId}**/sales/invoices'
  },
  SUBSCRIPTIONS: {
    from: /contacts\/\d+\/objects\/0-69/i,
    to: '/object-type-settings/**{portalId}**/object/0-69'
  },
  PRODUCTS: {
    from: /contacts\/\d+\/objects\/0-7/i,
    to: '/settings/**{portalId}**/sales/products'
  },
  CUSTOM_OBJECTS: {
    from: /(sales|contacts)\/\d+\/objects/i,
    to: '/sales-products-settings/**{portalId}**/object/'
  },
  FORMATTING_APP_CONTACTS: {
    from: /formatting-issues\/\d+\/contacts/i,
    to: '/sales-products-settings/**{portalId}**/contacts'
  },
  FORMATTING_APP_COMPANIES: {
    from: /formatting-issues\/\d+\/companies/i,
    to: '/sales-products-settings/**{portalId}**/companies'
  },
  HELPDESK: {
    from: /(help-desk)/,
    to: '/helpdesk-settings/**{portalId}**/inboxes'
  },
  HELPDESK_UPRADE: {
    from: /helpdesk-upgrade/,
    to: '/settings/**{portalId}**/user-preferences'
  },
  PROSPECTING: {
    from: 'prospecting',
    to: '/sales-workspace-settings/**{portalId}**'
  },
  MEMBERSHIPS: {
    from: /memberships\/\d+\/(access-groups|members)/i,
    to: '/settings/**{portalId}**/content-membership'
  },
  COMMERCE_HOME_PRE_ENROLL: {
    from: /commerce.*\/zero-state/i,
    to: '/settings/**{portalId}**/user-preferences'
  },
  COMMERCE_HOME: {
    from: 'commerce',
    to: '/settings/**{portalId}**/commerce-accounts'
  },
  CASE_STUDY: {
    from: 'case-study',
    to: '/settings/**{portalId}**/case-study'
  },
  LEADS: {
    from: 'lead-overview',
    to: '/leads-settings/**{portalId}**'
  },
  COURSE: {
    from: /contacts\/\d+\/(objects|record)\/0-410/gi,
    to: '/object-type-settings/**{portalId}**/object/0-410'
  },
  LISTING: {
    from: /contacts\/\d+\/(objects|record)\/0-420/gi,
    to: '/object-type-settings/**{portalId}**/object/0-420'
  },
  APPOINTMENT: {
    from: /contacts\/\d+\/(objects|record)\/0-421/gi,
    to: '/object-type-settings/**{portalId}**/object/0-421'
  },
  SERVICE: {
    from: /contacts\/\d+\/(objects|record)\/0-162/gi,
    to: '/object-type-settings/**{portalId}**/object/0-162'
  },
  CAMPAIGNS: {
    from: /marketing\/\d+\/campaigns/i,
    to: '/settings/**{portalId}**/marketing/campaigns/'
  },
  CUSTOMER_SUCCESS: {
    from: 'customer-success',
    to: '/customer-success-settings/**{portalId}**'
  },
  SMS: {
    from: 'sms',
    to: '/settings/**{portalId}**/messaging/sms'
  },
  WORKFLOWS: {
    from: 'workflows',
    to: '/settings/**{portalId}**/user-preferences/workflows'
  }
};
export default settingsUrlMappings;